import { useMutation, useQueryClient } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { encodeFunctionData, parseEther } from "viem";
import { waitForTransactionReceipt } from "viem/actions";
import { useAccount, useChainId, useWalletClient } from "wagmi";

import { stakingAbi } from "shared/config/abi/staking-abi";
import { galacticaStakeContractConfig } from "shared/config/const";

type Params = {
  amount: string;
  validatorAddress: string;
};

export const useUndelegateMutation = () => {
  const { address: accountAddress } = useAccount();
  const chainId = useChainId();
  const { data: wc } = useWalletClient({ chainId });
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ amount, validatorAddress }: Params) => {
      invariant(wc);
      invariant(accountAddress);

      const contractAddress = galacticaStakeContractConfig[chainId];

      const parsedAmount = parseEther(amount);

      console.log("useDelegateMutation", parsedAmount);

      const data = encodeFunctionData({
        abi: stakingAbi,
        functionName: "undelegate",
        args: [accountAddress, validatorAddress, parsedAmount],
      });

      const hash = await wc.sendTransaction({
        data,
        to: contractAddress,
        from: accountAddress,
        account: accountAddress,
      });

      const receipt = await waitForTransactionReceipt(wc, { hash });

      return receipt;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["cosmos"],
      });
    },
  });
};
